import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, Paperclip, Trash2 } from "lucide-react";
import { toast } from "sonner";

const fmt = (s) => new Date(s).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "medium", timeStyle: "short" });

async function openFile(f) {
  try {
    const r = await api.get(`/forms/files/${f.id}`, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  } catch { toast.error("Gagal membuka file"); }
}

function Cell({ q, v }) {
  if (v === undefined || v === null || v === "") return <span className="text-slate-300">—</span>;
  if (q.type === "checkbox") return v.join(", ");
  if (q.type === "file") return (
    <div className="space-y-1">{v.map((f) => (
      <button key={f.id} onClick={() => openFile(f)} className="flex items-center gap-1 text-indigo-600 hover:underline text-left"><Paperclip className="h-3.5 w-3.5 shrink-0" />{f.name}</button>
    ))}</div>
  );
  return String(v);
}

export function FormResponses({ form, onCount }) {
  const [rows, setRows] = useState([]);
  const load = () => api.get(`/forms/${form.id}/responses`).then((r) => { setRows(r.data); onCount?.(r.data.length); });
  useEffect(() => { load(); }, [form.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const exportXlsx = async () => {
    try {
      const r = await api.get(`/forms/${form.id}/export.xlsx`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data); a.download = `rekap_${form.title}.xlsx`; a.click();
    } catch { toast.error("Gagal mengunduh rekap"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Hapus jawaban ini?")) return;
    await api.delete(`/forms/${form.id}/responses/${id}`); toast.success("Jawaban dihapus"); load();
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
        <p className="text-slate-600"><span className="text-2xl font-extrabold text-slate-900" data-testid="responses-count">{rows.length}</span> jawaban</p>
        <Button onClick={exportXlsx} data-testid="export-form-xlsx-btn" className="bg-emerald-600 hover:bg-emerald-700"><Download className="h-4 w-4 mr-1" />Unduh Rekap Excel</Button>
      </div>
      {rows.length === 0 ? (
        <div className="text-center py-14 text-slate-400 rounded-2xl border border-dashed border-slate-200" data-testid="responses-empty">Belum ada jawaban masuk.</div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white zoa-scroll" data-testid="responses-table">
          <table className="min-w-full text-sm">
            <thead className="bg-indigo-50 text-indigo-900">
              <tr>
                <th className="px-3 py-2 text-left font-semibold whitespace-nowrap">Waktu</th>
                <th className="px-3 py-2 text-left font-semibold whitespace-nowrap">Pengisi</th>
                {form.questions.map((q) => <th key={q.id} className="px-3 py-2 text-left font-semibold min-w-[160px]">{q.label}</th>)}
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`response-row-${r.id}`}>
                  <td className="px-3 py-2 whitespace-nowrap text-slate-500">{fmt(r.created_at)}</td>
                  <td className="px-3 py-2 whitespace-nowrap font-medium">{r.respondent_name}</td>
                  {form.questions.map((q) => <td key={q.id} className="px-3 py-2"><Cell q={q} v={r.answers?.[q.id]} /></td>)}
                  <td className="px-2 py-2"><button onClick={() => remove(r.id)} className="text-slate-300 hover:text-rose-500" data-testid={`delete-response-${r.id}`}><Trash2 className="h-4 w-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
